// source: v3/types/sip_trunk.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.loopup.ctgateway.v3.SipEndPoint', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.SipNumber', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.SipTrunk', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.SipTrunkProtocol', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v3.SipTrunkTrafficDistributionMethod', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.SipEndPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.SipEndPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.SipEndPoint.displayName = 'proto.loopup.ctgateway.v3.SipEndPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.SipTrunk = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loopup.ctgateway.v3.SipTrunk.repeatedFields_, null);
};
goog.inherits(proto.loopup.ctgateway.v3.SipTrunk, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.SipTrunk.displayName = 'proto.loopup.ctgateway.v3.SipTrunk';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v3.SipNumber = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v3.SipNumber, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v3.SipNumber.displayName = 'proto.loopup.ctgateway.v3.SipNumber';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.SipEndPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.SipEndPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.SipEndPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.SipEndPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
    endpoint: jspb.Message.getFieldWithDefault(msg, 1, ""),
    priority: jspb.Message.getFieldWithDefault(msg, 2, 0),
    isHealthy: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    canConnectWithTls: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    sipEndpointId: (f = msg.getSipEndpointId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.SipEndPoint}
 */
proto.loopup.ctgateway.v3.SipEndPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.SipEndPoint;
  return proto.loopup.ctgateway.v3.SipEndPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.SipEndPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.SipEndPoint}
 */
proto.loopup.ctgateway.v3.SipEndPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndpoint(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPriority(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsHealthy(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanConnectWithTls(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSipEndpointId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.SipEndPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.SipEndPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.SipEndPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.SipEndPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEndpoint();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPriority();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getIsHealthy();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getCanConnectWithTls();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getSipEndpointId();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string endpoint = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.SipEndPoint.prototype.getEndpoint = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.SipEndPoint} returns this
 */
proto.loopup.ctgateway.v3.SipEndPoint.prototype.setEndpoint = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 priority = 2;
 * @return {number}
 */
proto.loopup.ctgateway.v3.SipEndPoint.prototype.getPriority = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v3.SipEndPoint} returns this
 */
proto.loopup.ctgateway.v3.SipEndPoint.prototype.setPriority = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool is_healthy = 3;
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.SipEndPoint.prototype.getIsHealthy = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.loopup.ctgateway.v3.SipEndPoint} returns this
 */
proto.loopup.ctgateway.v3.SipEndPoint.prototype.setIsHealthy = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool can_connect_with_tls = 4;
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.SipEndPoint.prototype.getCanConnectWithTls = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.loopup.ctgateway.v3.SipEndPoint} returns this
 */
proto.loopup.ctgateway.v3.SipEndPoint.prototype.setCanConnectWithTls = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional google.protobuf.StringValue sip_endpoint_id = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v3.SipEndPoint.prototype.getSipEndpointId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v3.SipEndPoint} returns this
*/
proto.loopup.ctgateway.v3.SipEndPoint.prototype.setSipEndpointId = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.SipEndPoint} returns this
 */
proto.loopup.ctgateway.v3.SipEndPoint.prototype.clearSipEndpointId = function() {
  return this.setSipEndpointId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.SipEndPoint.prototype.hasSipEndpointId = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loopup.ctgateway.v3.SipTrunk.repeatedFields_ = [8,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.SipTrunk.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.SipTrunk.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.SipTrunk} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.SipTrunk.toObject = function(includeInstance, msg) {
  var f, obj = {
    sipTrunkId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    customerId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    regionName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    protocol: jspb.Message.getFieldWithDefault(msg, 5, 0),
    trafficDistributionMethod: jspb.Message.getFieldWithDefault(msg, 6, 0),
    description: (f = msg.getDescription()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    sipNumbersList: jspb.Message.toObjectList(msg.getSipNumbersList(),
    proto.loopup.ctgateway.v3.SipNumber.toObject, includeInstance),
    sipEndpointsList: jspb.Message.toObjectList(msg.getSipEndpointsList(),
    proto.loopup.ctgateway.v3.SipEndPoint.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.SipTrunk}
 */
proto.loopup.ctgateway.v3.SipTrunk.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.SipTrunk;
  return proto.loopup.ctgateway.v3.SipTrunk.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.SipTrunk} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.SipTrunk}
 */
proto.loopup.ctgateway.v3.SipTrunk.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSipTrunkId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegionName(value);
      break;
    case 5:
      var value = /** @type {!proto.loopup.ctgateway.v3.SipTrunkProtocol} */ (reader.readEnum());
      msg.setProtocol(value);
      break;
    case 6:
      var value = /** @type {!proto.loopup.ctgateway.v3.SipTrunkTrafficDistributionMethod} */ (reader.readEnum());
      msg.setTrafficDistributionMethod(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDescription(value);
      break;
    case 8:
      var value = new proto.loopup.ctgateway.v3.SipNumber;
      reader.readMessage(value,proto.loopup.ctgateway.v3.SipNumber.deserializeBinaryFromReader);
      msg.addSipNumbers(value);
      break;
    case 9:
      var value = new proto.loopup.ctgateway.v3.SipEndPoint;
      reader.readMessage(value,proto.loopup.ctgateway.v3.SipEndPoint.deserializeBinaryFromReader);
      msg.addSipEndpoints(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.SipTrunk.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.SipTrunk.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.SipTrunk} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.SipTrunk.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSipTrunkId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCustomerId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRegionName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getProtocol();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getTrafficDistributionMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getDescription();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSipNumbersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.loopup.ctgateway.v3.SipNumber.serializeBinaryToWriter
    );
  }
  f = message.getSipEndpointsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.loopup.ctgateway.v3.SipEndPoint.serializeBinaryToWriter
    );
  }
};


/**
 * optional string sip_trunk_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.SipTrunk.prototype.getSipTrunkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.SipTrunk} returns this
 */
proto.loopup.ctgateway.v3.SipTrunk.prototype.setSipTrunkId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.loopup.ctgateway.v3.SipTrunk.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.SipTrunk} returns this
 */
proto.loopup.ctgateway.v3.SipTrunk.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string customer_id = 3;
 * @return {string}
 */
proto.loopup.ctgateway.v3.SipTrunk.prototype.getCustomerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.SipTrunk} returns this
 */
proto.loopup.ctgateway.v3.SipTrunk.prototype.setCustomerId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string region_name = 4;
 * @return {string}
 */
proto.loopup.ctgateway.v3.SipTrunk.prototype.getRegionName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.SipTrunk} returns this
 */
proto.loopup.ctgateway.v3.SipTrunk.prototype.setRegionName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional SipTrunkProtocol protocol = 5;
 * @return {!proto.loopup.ctgateway.v3.SipTrunkProtocol}
 */
proto.loopup.ctgateway.v3.SipTrunk.prototype.getProtocol = function() {
  return /** @type {!proto.loopup.ctgateway.v3.SipTrunkProtocol} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v3.SipTrunkProtocol} value
 * @return {!proto.loopup.ctgateway.v3.SipTrunk} returns this
 */
proto.loopup.ctgateway.v3.SipTrunk.prototype.setProtocol = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional SipTrunkTrafficDistributionMethod traffic_distribution_method = 6;
 * @return {!proto.loopup.ctgateway.v3.SipTrunkTrafficDistributionMethod}
 */
proto.loopup.ctgateway.v3.SipTrunk.prototype.getTrafficDistributionMethod = function() {
  return /** @type {!proto.loopup.ctgateway.v3.SipTrunkTrafficDistributionMethod} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v3.SipTrunkTrafficDistributionMethod} value
 * @return {!proto.loopup.ctgateway.v3.SipTrunk} returns this
 */
proto.loopup.ctgateway.v3.SipTrunk.prototype.setTrafficDistributionMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional google.protobuf.StringValue description = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v3.SipTrunk.prototype.getDescription = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v3.SipTrunk} returns this
*/
proto.loopup.ctgateway.v3.SipTrunk.prototype.setDescription = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v3.SipTrunk} returns this
 */
proto.loopup.ctgateway.v3.SipTrunk.prototype.clearDescription = function() {
  return this.setDescription(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v3.SipTrunk.prototype.hasDescription = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * repeated SipNumber sip_numbers = 8;
 * @return {!Array<!proto.loopup.ctgateway.v3.SipNumber>}
 */
proto.loopup.ctgateway.v3.SipTrunk.prototype.getSipNumbersList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v3.SipNumber>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.loopup.ctgateway.v3.SipNumber, 8));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v3.SipNumber>} value
 * @return {!proto.loopup.ctgateway.v3.SipTrunk} returns this
*/
proto.loopup.ctgateway.v3.SipTrunk.prototype.setSipNumbersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.loopup.ctgateway.v3.SipNumber=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v3.SipNumber}
 */
proto.loopup.ctgateway.v3.SipTrunk.prototype.addSipNumbers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.loopup.ctgateway.v3.SipNumber, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v3.SipTrunk} returns this
 */
proto.loopup.ctgateway.v3.SipTrunk.prototype.clearSipNumbersList = function() {
  return this.setSipNumbersList([]);
};


/**
 * repeated SipEndPoint sip_endpoints = 9;
 * @return {!Array<!proto.loopup.ctgateway.v3.SipEndPoint>}
 */
proto.loopup.ctgateway.v3.SipTrunk.prototype.getSipEndpointsList = function() {
  return /** @type{!Array<!proto.loopup.ctgateway.v3.SipEndPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.loopup.ctgateway.v3.SipEndPoint, 9));
};


/**
 * @param {!Array<!proto.loopup.ctgateway.v3.SipEndPoint>} value
 * @return {!proto.loopup.ctgateway.v3.SipTrunk} returns this
*/
proto.loopup.ctgateway.v3.SipTrunk.prototype.setSipEndpointsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.loopup.ctgateway.v3.SipEndPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loopup.ctgateway.v3.SipEndPoint}
 */
proto.loopup.ctgateway.v3.SipTrunk.prototype.addSipEndpoints = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.loopup.ctgateway.v3.SipEndPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loopup.ctgateway.v3.SipTrunk} returns this
 */
proto.loopup.ctgateway.v3.SipTrunk.prototype.clearSipEndpointsList = function() {
  return this.setSipEndpointsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v3.SipNumber.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v3.SipNumber.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v3.SipNumber} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.SipNumber.toObject = function(includeInstance, msg) {
  var f, obj = {
    ddi: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v3.SipNumber}
 */
proto.loopup.ctgateway.v3.SipNumber.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v3.SipNumber;
  return proto.loopup.ctgateway.v3.SipNumber.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v3.SipNumber} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v3.SipNumber}
 */
proto.loopup.ctgateway.v3.SipNumber.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDdi(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v3.SipNumber.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v3.SipNumber.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v3.SipNumber} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v3.SipNumber.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDdi();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string ddi = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v3.SipNumber.prototype.getDdi = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v3.SipNumber} returns this
 */
proto.loopup.ctgateway.v3.SipNumber.prototype.setDdi = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * @enum {number}
 */
proto.loopup.ctgateway.v3.SipTrunkProtocol = {
  SIP_TRUNK_PROTOCOL_INVALID: 0,
  SIP_TRUNK_PROTOCOL_TCP: 1,
  SIP_TRUNK_PROTOCOL_TLS: 2,
  SIP_TRUNK_PROTOCOL_UDP: 3
};

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v3.SipTrunkTrafficDistributionMethod = {
  SIP_TRUNK_TRAFFIC_DISTRIBUTION_METHOD_INVALID: 0,
  SIP_TRUNK_TRAFFIC_DISTRIBUTION_METHOD_ROUNDROBIN: 1,
  SIP_TRUNK_TRAFFIC_DISTRIBUTION_METHOD_FAILOVER: 2
};

goog.object.extend(exports, proto.loopup.ctgateway.v3);
